export const GEAR = [
    {
        id: "orvis-clearwater-outfit",
        name: "Orvis Clearwater Fly Rod Outfit",
        category: "Fly Rods",
        vendor: "Cabela's Outfitter Choice",
        vendorType: "cabelas",
        price: "$349",
        rating: 4.8,
        reviews: 1240,
        image: "/gear/fly-casting.jpg",
        specs: ["9ft 5wt", "4-piece", "Reel + line included"],
        pros: ["Forgiving medium action for new casters", "Everything rigged out of the box", "25-year guarantee"],
        link: "https://www.cabelas.com/shop/en/orvis-clearwater-fly-rod-outfit",
        level: "Beginner",
        budget: "Mid",
    },
    {
        id: "redington-crosswater-combo",
        name: "Redington Crosswater Combo",
        category: "Fly Rods",
        vendor: "Available on Amazon",
        vendorType: "amazon",
        price: "$179",
        rating: 4.6,
        reviews: 860,
        image: "/gear/flyfishing-set.jpg",
        specs: ["9ft 5wt", "Pre-spooled", "Cordura tube"],
        pros: ["Best value starter kit we tested", "Surprisingly crisp cast", "Tough travel tube"],
        link: "https://www.amazon.com/s?k=redington+crosswater+fly+combo",
        level: "Beginner",
        budget: "Budget",
    },
    {
        id: "sage-foundation-rod",
        name: "Sage Foundation 590-4",
        category: "Fly Rods",
        vendor: "Cabela's Outfitter Choice",
        vendorType: "cabelas",
        price: "$550",
        rating: 4.9,
        reviews: 410,
        image: "https://images.unsplash.com/photo-1724514415178-c87e1d00acd0?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
        specs: ["9ft 5wt", "Fast action", "Graphite IIIe"],
        pros: ["Laser accuracy at 40ft", "Lifetime craftmanship", "Handles wind and streamers"],
        link: "https://www.cabelas.com/shop/en/sage-foundation-fly-rod",
        level: "Advanced",
        budget: "Premium",
    },
    {
        id: "umpqua-fly-assortment",
        name: "Umpqua Trout Fly Assortment — 48pc",
        category: "Flies",
        vendor: "Available on Amazon",
        vendorType: "amazon",
        price: "$64",
        rating: 4.5,
        reviews: 720,
        image: "/gear/ts-flybox.webp",
        specs: ["48 flies", "Nymphs + dries + emergers", "Fly box included"],
        pros: ["Covers every major hatch", "Sharp barbless hooks", "Great first fly box"],
        link: "https://www.amazon.com/s?k=umpqua+trout+fly+assortment",
        level: "Beginner",
        budget: "Budget",
    },
    {
        id: "simms-freestone-waders",
        name: "Simms Freestone Stockingfoot Waders",
        category: "Waders",
        vendor: "Cabela's Outfitter Choice",
        vendorType: "cabelas",
        price: "$279",
        rating: 4.7,
        reviews: 980,
        image: "/gear/waders.jpg",
        specs: ["4-layer Toray", "Fleece hand pocket", "Gravel guards"],
        pros: ["Breathable in summer, warm in spring", "Bomber seams", "Articulated knees for scrambling"],
        link: "https://www.cabelas.com/shop/en/simms-freestone-waders",
        level: "Intermediate",
        budget: "Premium",
    },
    {
        id: "fishpond-nomad-net",
        name: "Fishpond Nomad Emerger Net",
        category: "Accessories",
        vendor: "Available on Amazon",
        vendorType: "amazon",
        price: "$119",
        rating: 4.8,
        reviews: 640,
        image: "https://images.unsplash.com/photo-1689709105115-e11810b6c425?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
        specs: ["Carbon/fiberglass", "Rubber bag", "Floats"],
        pros: ["Gentle on trout slime and fins", "Light enough to forget", "Floats when you drop it"],
        link: "https://www.amazon.com/s?k=fishpond+nomad+net",
        level: "Beginner",
        budget: "Mid",
    },
];

export const GEAR_CATEGORIES = ["All", "Fly Rods", "Flies", "Waders", "Accessories"];
